import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChangePassword } from '../models/index';
import { Session } from '../services/index';

@Component({
    selector: 'signup-password',
    templateUrl: 'signup-password.html'
})
export class SignupPassword {
  password: ChangePassword = new ChangePassword;
  passwordFormGroup: FormGroup;
  strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
  mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");
  value: number = 0;
      
  constructor(private fb: FormBuilder,
              private router: Router,
              private session: Session) {
    this.passwordFormGroup = this.fb.group({
        'password1': new FormControl(this.password.password1, Validators.required),
        'password2': new FormControl(this.password.password2, Validators.required)
        }, {
          validator: this.matchPassword // your validation method
        });
  }

  analyze(value) {
    let text = document.getElementById('password-strength-text');
    if (value && value.length > 0) {
      let meter = document.getElementById('password-strength-meter');
      
      if(this.strongRegex.test(value)) {
        this.value = 3;
        text.innerHTML = 'Password Strength: Strong';
      } else if(this.mediumRegex.test(value)) {
        this.value = 2;
        text.innerHTML = 'Password Strength: Medium';
      } else {
        this.value = 1;
        text.innerHTML = 'Password Strength: Weak';
      }
    } else {
      this.value = 0;
    }
  };

  matchPassword(control: AbstractControl) {
    let password = control.get('password1').value; // to get value in input tag
    let confirmPassword = control.get('password2').value; // to get value in input tag
    if(password != confirmPassword) {
      control.get('password2').setErrors( {match: true} )
    } else {
      control.get('password2').setErrors(null);
    }
  }

  get password1() { return this.passwordFormGroup.get('password1'); }
  get password2() { return this.passwordFormGroup.get('password2'); }     

  continue() {
    this.session.patient.password = this.password1.value;
    this.router.navigate(['/signup-plan' ]);
  }
}